var scroll = {};

(function () {
  scroll = {
    selectors: {
      flashes: 'flash-container'
    },
    variables: {
      interval: null,
      factor: 10,
      height: 0
    },
    methods: {
      scrollByOne: function () {
        var currentTop = scroll.helpers.bodyOffset()

        if (currentTop > scroll.variables.height) {
          if (currentTop - scroll.variables.factor < scroll.variables.height) {
            window.scrollTo(0, scroll.variables.height)
          } else {
            window.scrollTo(0, currentTop - scroll.variables.factor)
          }
        } else {
          clearInterval(scroll.variables.interval)
        }
      },
      smoothScrollTo: function (target) {
        scroll.variables.count = 0
        var height = target.getBoundingClientRect().top

        if (scroll.helpers.bodyOffset() - height <= 20) return

        scroll.variables.height = scroll.helpers.bodyOffset() - (height * (-1)) - 80
        scroll.variables.interval = setInterval(function () { scroll.methods.scrollByOne() })
      },
      scrollToFlash: function () {
        var target = document.getElementById('flash-container')
        scroll.methods.smoothScrollTo(target)
      },
      scrollToTop: function () {
        window.scrollTo(0, 0)
      }
    },
    helpers: {
      bodyOffset: function () {
        return document.scrollingElement.scrollTop
      }
    }
  }
})()

export default {
  smoothScrollTo: scroll.methods.smoothScrollTo,
  scrollToTop: scroll.methods.scrollToTop,
  scrollToFlash: scroll.methods.scrollToFlash
}



// WEBPACK FOOTER //
// ./src/utils/scroll.js